import { Descriptions } from "antd";
import type { Tag } from "../../../../../app/features/admin/admin.types";
import CustomModal from "../../../../../components/CustomModal";
import StatusTag from "../../../../../components/StatusTag";
import type { ModalType } from "../../../../../hooks/useModal";
import { formatDate } from "../../../../../utils/time.utils";

interface TagDetailsProps {
  open: boolean;
  onCancel: () => void;
  tag?: Tag | null;
  type?: ModalType["type"];
}

const TagDetails = ({ open, onCancel, tag }: TagDetailsProps) => {
  if (!tag) return null;

  return (
    <CustomModal
      title="Tag Details"
      open={open}
      handleClose={onCancel}
      footer={null}
      width={500}
    >
      <Descriptions column={1} bordered>
        <Descriptions.Item label="ID">{tag.id}</Descriptions.Item>
        <Descriptions.Item label="Name">{tag.name}</Descriptions.Item>
        {/* <Descriptions.Item label="Slug">{tag.slug}</Descriptions.Item> */}
        <Descriptions.Item label="Status">
          <StatusTag
            value={tag.isActive ? "active" : "inactive"}
            config={[
              { value: "active", label: "Active", className: "status-success" },
              {
                value: "inactive",
                label: "Inactive",
                className: "status-error",
              },
            ]}
          />
        </Descriptions.Item>
        <Descriptions.Item label="Created At">
          {formatDate(tag.createdAt)}
        </Descriptions.Item>
        <Descriptions.Item label="Updated At">
          {formatDate(tag.updatedAt)}
        </Descriptions.Item>
      </Descriptions>
    </CustomModal>
  );
};

export default TagDetails;
